import { X } from "lucide-react";

const EquipmentModal = ({ data, onClose }) => {

  const equipments = data?.equipments ?? [];
  const totalEquipment = equipments?.reduce(
    (sum, item) => sum + (item?.quantity || 0),
    0
  );

  return (
    <div className="training-modal-overlay">

      <div className="equipment-modal">

        {/* Header */}
        <div className="modal-header">
          <h5>Equipment ({totalEquipment})</h5>

          <button className="icon-btn" onClick={onClose}>
            <X size={18} />
          </button>
        </div>


        {/* Equipment Grid */}
        <div className="equipment-modal-grid">
          {data?.equipments?.length > 0 ? (
            data?.equipments?.map((item, i) => (
              <div key={i} className="equipment-modal-card">

              <div className="equipment-modal-left">

                <div className="equipment-modal-img">
                  <img
                    src={item.image || "/images/equipment.png"}
                    alt=""
                  />
                </div>

                <div className="equipment-modal-info">
                  <span className="equipment-modal-type">{item?.category_name}</span>
                  <h6>{item?.item_name}</h6>
                </div>

              </div>


              <div className="equipment-modal-qty">
                {item?.quantity}
              </div>

            </div>
          ))): (
            <p className="no-equipment">No equipment allocated</p>
          )
          }

        </div>

      </div>

    </div>
  );
};

export default EquipmentModal;